//*** Lib */
import Cookies from 'universal-cookie';
import { getCookieMaxAge } from "../date/formatDate";
import { decryptStorageData, encryptSotrageData } from '../../services/CryptoService';
import { cookieDomainConfig } from "../../services/api/helper/configuration/Configurations";

const cookies = new Cookies();
const COOKIE_DOMAIN = cookieDomainConfig.cookieDomain;

export const createCookie = (props) => {
    let cookieValue = encryptSotrageData(props.cookieValue);
    let cookieName = props.cookieName;
    const maxAge = getCookieMaxAge(props.expirationTime);
    cookies.set(cookieName, cookieValue,
        {
            path: props?.path || '/',
            maxAge: maxAge,
            ...(COOKIE_DOMAIN && { domain: COOKIE_DOMAIN }),
        });
};

export const setCookie = (props) => {
    let cookieValue = encryptSotrageData(props.cookieValue);
    let cookieName = props.cookieName;
    cookies.set(cookieName, cookieValue, {
        path: props?.path || '/',
        ...(COOKIE_DOMAIN && { domain: COOKIE_DOMAIN }),
    });
};

export function getCookie(cookieName, doNotParse = false) {
    const cookieValue = cookies.get(cookieName, { doNotParse: true });
    if (cookieValue) {
        return decryptStorageData(cookieValue);
    }
    else {
        return null;
    }
};

export const getAllCookies = (doNotParse = false) => {
    const cookieValue = cookies.getAll({ doNotParse: doNotParse });
    return decryptStorageData(cookieValue);
};

export const removeCookie = (cookieName, options = {}) => {
    cookies.remove(cookieName, { path: '/', ...options, ...(COOKIE_DOMAIN && { domain: COOKIE_DOMAIN }) });
    if (COOKIE_DOMAIN) {
        cookies.remove(cookieName, { path: '/', ...options });
    }
};

export const removeAllCookies = () => {
    const allCookies = cookies.getAll({ doNotParse: true });
    Object.keys(allCookies).forEach(element => {
        cookies.remove(element, { path: '/', ...(COOKIE_DOMAIN && { domain: COOKIE_DOMAIN }) });
        if (COOKIE_DOMAIN) {
            cookies.remove(element, { path: '/' });
        }
    });
};

export const isCookieExist = (cookieName) => !!getCookie(cookieName);